const config = {
  rowSelection: false,
  columns: [
    {
      title: '退款申请单号',
      dataIndex: 'billNo',
      render: "IdRender",
      width: 180,
    },
    {
      title: '退款类型',
      dataIndex: 'refundTypeName',
      width: 120
    },
    {
      title: '申请时间',
      dataIndex: 'applyTime',
      itemType: 'dateTime',
      width: 160,
    },
    {
      title: '退款金额',
      dataIndex: 'refundAmount',
      width: 120,
    },
    {
      title: '支付方式',
      dataIndex: 'payTypeName',
      width: 120,
    },
    {
      title: '是否原路退回',
      dataIndex: 'backTrackFlagName',
      width: 150
    },
    {
      title: '退款状态',
      dataIndex: 'refundStateName',
      width: 120
    },
    {
      title: '退款支付状态',
      dataIndex: 'payStateName',
      width: 150
    },
    {
      title: '支付异常原因',
      dataIndex: 'payException',
      ellipsis: true,
      width: 200
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 220,
      render: 'renderOperate',
      fixed: 'right'
    },
  ],
  search: [],
  footer: [
    {
      label: '去退款',
      type: 'primary',
      disabled: 'skipDisabled',
      auth: 'RefundConfirmationSkip',
      events: ['onClick:onSkip'],
    },
  ]
}
export default config
